const BASE = 'https://imalishawelfare.com/api';

export const getToken  = ()  => sessionStorage.getItem('token');
export const setToken  = (t) => sessionStorage.setItem('token', t);
export const getUser   = ()  => { try { return JSON.parse(sessionStorage.getItem('user')); } catch { return null; } };
export const setUser   = (u) => sessionStorage.setItem('user', JSON.stringify(u));
export const clearAuth = ()  => { sessionStorage.removeItem('token'); sessionStorage.removeItem('user'); };
export const isLoggedIn= ()  => !!getToken();

async function req(endpoint, options = {}) {
  const token = getToken();
  const res = await fetch(BASE + endpoint, {
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: 'Bearer ' + token } : {}), ...options.headers },
    ...options,
  });
  let data;
  try { data = await res.json(); } catch { data = {}; }
  if (res.status === 401) { clearAuth(); throw new Error('Session expired. Please log in again.'); }
  if (!res.ok) throw new Error(data.message || 'Error ' + res.status);
  return data;
}

export async function loginBeneficiary(email, password) {
  const data = await req('/auth/login', { method: 'POST', body: JSON.stringify({ email, password }) });
  if (data.token) { setToken(data.token); setUser({ email: data.email, role: data.role }); }
  return data;
}

export async function loginAdmin(email, password) {
  const data = await req('/auth/login', { method: 'POST', body: JSON.stringify({ email, password }) });
  if (data.role !== 'ADMIN') throw new Error('Access denied. Admin credentials required.');
  if (data.token) { setToken(data.token); setUser({ email: data.email, role: data.role }); }
  return data;
}

export const submitApplication       = (body)         => req('/applications/submit', { method: 'POST', body: JSON.stringify(body) });
export const getAllApplications       = ()             => req('/applications');
export const approveApplication      = (id, notes)    => req('/applications/' + id + '/approve', { method: 'PUT', body: JSON.stringify({ adminNotes: notes || '' }) });
export const rejectApplication       = (id, reason)   => req('/applications/' + id + '/reject',  { method: 'PUT', body: JSON.stringify({ rejectionReason: reason }) });
export const getBeneficiaryDashboard = ()             => req('/beneficiary/dashboard');
export const getBeneficiaryPayments  = ()             => req('/beneficiary/payments');
export const getAdminStats           = ()             => req('/admin/stats');
export const getAllBeneficiaries      = ()             => req('/admin/beneficiaries');
export const toggleBeneficiaryStatus = (id)           => req('/admin/beneficiaries/' + id + '/toggle-status', { method: 'PUT' });
export const disbursePayment         = (appId)        => req('/loans/admin/disburse/' + appId, { method: 'PUT' });
export const getAllPayments           = ()             => req('/admin/payments');
export const getAnalytics            = ()             => req('/admin/analytics');



